import { useRef } from "react";

import {
  DEFAULT_AXIS_FONT_SIZE,
  DEFAULT_AXIS_LABEL_FONT_SIZE,
  DEFAULT_LEGEND_FONT_SIZE,
  DEFAULT_TITLE_FONT_SIZE
} from "constants/chart.constants";
import { THEME_FONT_FAMILY } from "constants/style.constants";
import { applyScreenshotSettings } from "utils";

import { IChartScreenshotSettings } from "models/chart";
import { IScreenshotAbbreviation } from "models/screenshot";

export function useScreenshotApply(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartRef: React.MutableRefObject<any>,
  setting: IChartScreenshotSettings,
  abbreviations: IScreenshotAbbreviation[],
  screenshotVisible: boolean | undefined
) {
  const screenshotApplyRef = useRef<(() => void) | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const applyOptions = (option: any) => {
    if (!chartRef.current) return;

    const screenshotSettings: IChartScreenshotSettings = {
      titleFontSize: setting?.titleFontSize ?? DEFAULT_TITLE_FONT_SIZE,
      axisFontSize: setting?.axisFontSize ?? DEFAULT_AXIS_FONT_SIZE,
      axisLabelFontSize: setting?.axisLabelFontSize ?? DEFAULT_AXIS_LABEL_FONT_SIZE,
      legendFontSize: setting?.legendFontSize ?? DEFAULT_LEGEND_FONT_SIZE,
      fontFamily: setting?.fontFamily ?? THEME_FONT_FAMILY,
      legendType: "bottom",
      legendVisible: setting?.legendVisible,
      applyAbbreviations: setting?.applyAbbreviations ?? false,
      xAxisTitleText: option?.xAxis?.name
    };

    const applyScreenshot = () => {
      if (!chartRef.current) return;
      chartRef.current.setOption(
        applyScreenshotSettings(
          option,
          chartRef.current,
          screenshotSettings,
          abbreviations
        )
      );
      // Second pass: reads _componentsViews from the first pass for the correct legend height.
      chartRef.current.setOption(
        applyScreenshotSettings(
          option,
          chartRef.current,
          screenshotSettings,
          abbreviations
        )
      );
    };

    if (screenshotVisible) {
      screenshotApplyRef.current = applyScreenshot;
      applyScreenshot();
    } else {
      screenshotApplyRef.current = null;
      chartRef.current.setOption(option);
    }
  };

  return { screenshotApplyRef, applyOptions };
}
